export class AdContentElement {
	key?: string;
	content?: string;
	metadata?: string;
}
